import { jwtDecode } from "jwt-decode";


export const decodeJWT = (token: string) => {

    
    try {
      const decoded = jwtDecode(token);  
      return {...decoded||{}} 
    } catch (error) {
      return {};
    }
};
